import { Box, VStack, Checkbox, Input, Select, Text } from "@chakra-ui/react";

export interface ObjectsFilterPanelProps {
  search: string;
  checkboxes: {
    rule: boolean;
    process: boolean;
    customDataType: boolean;
    connectedSystems: boolean;
    integration: boolean;
    floder: boolean;
    recordType: boolean;
    webApi: boolean;
  };
  timeRange?: string;
  onFilterChange: (filters: {
    search?: string;
    checkboxes: {
      rule: boolean;
      process: boolean;
      customDataType: boolean;
      connectedSystems: boolean;
      integration: boolean;
      floder: boolean;
      recordType: boolean;
      webApi: boolean;
    };
    timeRange?: string;
  }) => void;
}

export const ObjectsFilterPanel = ({
  search,
  checkboxes,
  timeRange,
  onFilterChange,
}: ObjectsFilterPanelProps) => {
  return (
    <Box p={3}>
      <VStack align="start" spacing={3}>
        {/* Search Input */}
        <Input
          placeholder="Search by name or display name"
          value={search}
          onChange={(e) =>
            onFilterChange({
              search: e.target.value,
              checkboxes,
              timeRange,
            })
          }
          bg="rgba(255, 255, 255, 0.1)"
          borderColor="rgba(255, 255, 255, 0.2)"
          color="white"
          _placeholder={{ color: "rgba(255, 255, 255, 0.6)" }}
          _focus={{
            borderColor: "brand.500",
            boxShadow: "0 0 0 1px rgba(118, 82, 247, 0.5)",
          }}
        />

        {/* Checkbox Filters */}
        <Text fontWeight="bold" color="white" fontSize="sm">Filter by Type</Text>
        <Checkbox
          isChecked={checkboxes.rule}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, rule: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Rule">Rule</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.process}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, process: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Process">Process</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.customDataType}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, customDataType: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Custom Data Type">Custom Data Type</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.connectedSystems}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, connectedSystems: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Connected Systems">Connected Systems</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.integration}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, integration: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Integration">Integration</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.floder}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, floder: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Folder">Folder</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.recordType}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, recordType: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Record Type">Record Type</Text>
        </Checkbox>
        <Checkbox
          isChecked={checkboxes.webApi}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes: { ...checkboxes, webApi: e.target.checked },
              timeRange,
            })
          }
          colorScheme="brand"
          color="white"
          size="sm"
        >
          <Text fontSize="sm" noOfLines={1} title="Web API">Web API</Text>
        </Checkbox>

        {/* Time Range Select */}
        <Select
          placeholder="Select Time Range"
          value={timeRange}
          onChange={(e) =>
            onFilterChange({
              search,
              checkboxes,
              timeRange: e.target.value,
            })
          }
          bg="rgba(255, 255, 255, 0.1)"
          borderColor="rgba(255, 255, 255, 0.2)"
          color="white"
          _focus={{
            borderColor: "brand.500",
            boxShadow: "0 0 0 1px rgba(118, 82, 247, 0.5)",
          }}
        >
          <option value="time-all" style={{background: '#1a1a1a', color: 'white'}}>All Time</option>
          <option value="time-24h" style={{background: '#1a1a1a', color: 'white'}}>Last 24 Hours</option>
          <option value="time-7d" style={{background: '#1a1a1a', color: 'white'}}>Last 7 Days</option>
        </Select>
      </VStack>
    </Box>
  );
};
